import BaseAPI from '../helpers/base-api.js';
import { updateUserData } from '../redux/actions.js';

const baseAPI = new BaseAPI();

export const fetchFreshUserData = async (dispatch) => {
    try {
        const response = await baseAPI.get('/profile/me');
        const freshData = response.data;
        
        // Update localStorage and Redux
        localStorage.setItem('user', JSON.stringify(freshData));
        if (dispatch) {
            dispatch(updateUserData(freshData));
        }
        
        return freshData;
    } catch (error) {
        console.error('Failed to fetch fresh user data:', error);
        throw error;
    }
};

export const clearAndFetchUserData = async (dispatch) => {
    try {
        // Fetch fresh data first without clearing existing data
        const response = await baseAPI.get('/profile/me');
        const freshData = response.data;
        
        // Only update if fetch was successful
        localStorage.setItem('user', JSON.stringify(freshData));
        if (dispatch) {
            dispatch(updateUserData(freshData));
        }
        
        return freshData;
    } catch (error) {
        console.error('Failed to clear and fetch user data:', error);
        // Don't clear existing data if fetch fails
        throw error;
    }
};

